import { isNumber } from 'lodash';

interface ICurrencyTypeOption {
  precision: number;
  currencyFormat: string;
}

export const getFormattedArrayCurrency = (values: number[], typeOptions: ICurrencyTypeOption) =>
  (values && Array.isArray(values) ? values : [])
    .map((num: number) => getFormattedCurrency(num, typeOptions))
    .join(', ');

export const getFormattedCurrency = (
  value: number,
  typeOptions: {
    precision: number;
    currencyFormat: string;
  },
) => {
  if (!isNumber(value)) return null;

  // if value is Infinity, -Infinity, or NaN, we should not format it
  if (!isFinite(value)) return `${value}`;

  const precision = typeOptions ? typeOptions.precision : 0;
  const currencyFormat = typeOptions.currencyFormat;
  const currencyFormatted = Number(value.toFixed(precision)).toLocaleString('en', {
    maximumFractionDigits: precision,
    minimumFractionDigits: precision,
  });

  return `${currencyFormat}${currencyFormatted}`;
};
